import { Helpers } from '../../helpers';
import { IScheduleRelationshipType } from '../../interfaces/ischedule-relationship-type';
import { GroupRelationship } from '../group-relationship';
import { ScheduleRelationship } from '../schedule-relationship';

export class ScheduleRelationshipTypeBase {
  ScheduleRelationshipTypeId: number;
  ScheduleRelationshipCode: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  GroupRelationships_ScheduleRelationshipType?: Array<GroupRelationship> | null;
  ScheduleRelationships_ScheduleRelationshipType?: Array<ScheduleRelationship> | null;

  constructor(item?: IScheduleRelationshipType) {
    if (item) {

      this.ScheduleRelationshipTypeId = item.ScheduleRelationshipTypeId;
      this.ScheduleRelationshipCode = item.ScheduleRelationshipCode;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.GroupRelationships_ScheduleRelationshipType = Helpers.createClassArray(GroupRelationship, item.GroupRelationships_ScheduleRelationshipType);
      this.ScheduleRelationships_ScheduleRelationshipType = Helpers.createClassArray(ScheduleRelationship, item.ScheduleRelationships_ScheduleRelationshipType);
    }
  }
}